export default __webpack_public_path__ + "static/media/unchecked-checkbox-dark.ed285ae0.svg";